export default __webpack_public_path__ + "static/media/horizontal_right_to_left_above.4fdde910.PNG";